export function formatCurrency(amount: string, currency: string): string {
  const parsedAmount = Number(amount);

  if (Number.isNaN(parsedAmount)) return amount;

  return new Intl.NumberFormat("en-US", {
    currency,
    style: "currency",
  }).format(parsedAmount);
}
